<template>
  <div>
    <Toolbar>
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-key</v-icon>{{ item['login'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <br />

    <div v-if="item" class="table-connexionuser-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('administration.user.ipadress') }}</strong></td>
              <td>
                                    {{ item['ipAdress'] }}
              </td>

              <td><strong>{{ $t('administration.user.login') }}</strong></td>
              <td>
                                    {{ item['login'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('administration.user.date') }}</strong></td>
              <td>
                {{ formatDateTime(item['date'], 'long') }}              </td>

              <td><strong>{{ $t('administration.user.failed') }}</strong></td>
              <td>
                                    {{ item['failed'] }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'ConnexionUser';

export default {
  name: 'ConnexionUserShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('connexionuser', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('connexionuser', ['find'])
  },
  methods: {
    ...mapActions('connexionuser', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
